import {useQuery} from "@tanstack/react-query";
import * as api from "../../../api";
import {useTranslation} from "react-i18next";


export const useStationsQuery = (params, options = {}) => {
    return useQuery({
        queryKey: ['stations', params],
        queryFn: () => api.Station.getStations(params),
        keepPreviousData: true,
        ...options
    });
}

export const useModels1Query = (params, options = {}) => {
    return useQuery({
        queryKey: ['models1', params],
        queryFn: () => api.Model1.getModels1(params),
        keepPreviousData: true,
        ...options
    });
}

export const useModels23Query = (params, options = {}) => {
    return useQuery({
        queryKey: ['models23', params],
        queryFn: () => api.Model23.getModels23(params),
        keepPreviousData: true,
        ...options
    });
}

export const useIncidentsQuery = (params, options = {}) => {
    return useQuery({
        queryKey: ['incidents', params],
        queryFn: () => api.Public.Incidents.getIncidents(params),
        keepPreviousData: true,
        ...options
    });
}

export const useModel23Query = (model23Id, options={}) => {
    return useQuery({
        queryKey: ['models23', model23Id],
        queryFn: () => api.Model23.getModel23(model23Id),
        ...options
    });

}

export const useIncidentSettingsQuery = () => {
    return useQuery({
        queryKey: ['settings', 'incident'],
        queryFn: () => api.Settings.getIncidentSettings(),
        keepPreviousData: true,
        staleTime: 1000 * 60 * 60 * 24 * 7, // 1 week
    });
}

export const useIncidentRegistryQuery = () => {
    const {i18n} = useTranslation();
    const locale = i18n.language;

    return useQuery({
        queryKey: ['registry', 'incident', locale],
        queryFn: () => api.Registry.getIncidentRegistry(locale),
        keepPreviousData: true,
        staleTime: 1000 * 60 * 60 * 24 * 7, // 1 week
    });
}

export const usePublicIncidentQuery = (incidentId) => {
    return useQuery({
        queryKey: ['publicIncident', incidentId],
        queryFn: () => api.Public.Incidents.getIncident(incidentId),
        enabled: !!incidentId
    });
}

export const usePublicIncidentAttachmentsQuery = (incidentId) => {
    return useQuery({
        queryKey: ['publicIncident', incidentId, 'attachments'],
        queryFn: () => api.Public.Incidents.getIncidentAttachments(incidentId),
        enabled: !!incidentId
    });
}


export const useRegionQuery = (regionId, options = {}) => {
    return useQuery({
        queryKey: ['regions', regionId],
        queryFn: () => api.Territory.getRegion(regionId),
        enabled: !!regionId,
        ...options
    });
}

export const useProvinceQuery = (provinceId, options = {}) => {
    return useQuery({
        queryKey: ['provinces', provinceId],
        queryFn: () => api.Territory.getProvince(provinceId),
        enabled: !!provinceId,
        ...options
    });
}

export const useMunicipalityQuery = (municipalityId, options = {}) => {
    return useQuery({
        queryKey: ['municipalities', municipalityId],
        queryFn: () => api.Territory.getMunicipality(municipalityId),
        enabled: !!municipalityId,
        ...options
    });
}

export const useWebgisRegistryQuery = () => {
    const {i18n} = useTranslation();
    const locale = i18n.language;

    return useQuery({
        queryKey: ['registry', 'webgis', locale],
        queryFn: () => api.Registry.getWebgisRegistry(locale),
        keepPreviousData: true,
        staleTime: 1000 * 60 * 60 * 24 * 7, // 1 week
    });
}